











































































import Vue from 'vue';
import InputPassword from '@/components/common/form/InputPassword.vue';
import FormInput from '@/components/common/form/FormInput.vue';
import Errors from '@/components/common/form/Errors.vue';
import PasswordCriteria from '@/components/common/form/PasswordCriteria.vue';
import { createNamespacedHelpers } from 'vuex';
const { mapState, mapMutations, mapGetters } = createNamespacedHelpers('confirm');
const { mapMutations: mapMutationsResetPassword, mapGetters: mapGettersResetPassword } = createNamespacedHelpers(
    'resetPassword',
);
import zxcvbn from 'zxcvbn';
import {
    PASSWORD_LOWERCASE_REGEX,
    PASSWORD_MIN_LENGTH,
    PASSWORD_MIN_SCORE,
    PASSWORD_NUMBER_REGEX,
    PASSWORD_SPECIAL_CHAR_REGEX,
    PASSWORD_UPPERCASE_REGEX,
} from '@/utils/passwordConstants';

export default Vue.extend({
    components: {
        FormInput,
        InputPassword,
        Errors,
        PasswordCriteria,
    },
    computed: {
        ...mapState({
            password: 'password',
            passwordConfirmation: 'passwordConfirmation',
            passwordStrength: 'passwordStrength',
        }),
        ...mapGetters({ getFieldErrorsConfirm: 'getFieldErrors' }),
        ...mapGettersResetPassword({ getFieldErrorsResetPassword: 'getFieldErrors' }),
    },
    watch: {
        password: function(val) {
            this.setPasswordReset({ password: val });
            this.setPasswordStrength({
                passwordStrength: {
                    score: Math.min(zxcvbn(val).score * 33.34, 100),
                    meetsMinimumLengthRequirement: val.length >= PASSWORD_MIN_LENGTH,
                    containsUpperCaseLetter: PASSWORD_UPPERCASE_REGEX.test(val),
                    containsLowerCaseLetter: PASSWORD_LOWERCASE_REGEX.test(val),
                    containsAtLeastOneNumber: PASSWORD_NUMBER_REGEX.test(val),
                    containsSpecialCharacter: PASSWORD_SPECIAL_CHAR_REGEX.test(val),
                    isUncommonPassword: zxcvbn(val).score >= PASSWORD_MIN_SCORE,
                },
            });
        },
        passwordConfirmation: function(val) {
            this.setPasswordConfirmationReset({ passwordConfirmation: val });
        },
    },
    methods: {
        getPasswordStrengthClass(type: string) {
            const score = this.passwordStrength.score;
            const classes = {
                weak: `password-strength-meter-${type}-weak`,
                medium: `password-strength-meter-${type}-medium`,
                strong: `password-strength-meter-${type}-strong`,
            };

            if (score < 50) {
                return classes.weak;
            } else if (score <= 75) {
                return classes.medium;
            } else {
                return classes.strong;
            }
        },
        getPasswordStrengthLabel() {
            const score = this.passwordStrength.score;

            if (score < 25) {
                return '';
            } else if (score < 50) {
                return 'passwordRateWeak';
            } else if (score <= 75) {
                return 'passwordRateAverage';
            } else {
                return 'passwordRateStrong';
            }
        },
        getRelevantFieldErrors(field: string) {
            return this.getFieldErrorsConfirm(field) || this.getFieldErrorsResetPassword(field);
        },
        ...mapMutations(['setPassword', 'setPasswordConfirmation', 'setPasswordStrength']),
        ...mapMutationsResetPassword({
            setPasswordReset: 'setPassword',
            setPasswordConfirmationReset: 'setPasswordConfirmation',
        }),
    },
});
